import { render } from "./CenterTrimOnCanvas.vue?vue&type=template&id=2c28e7e6&scoped=true"
import script from "./CenterTrimOnCanvas.vue?vue&type=script&lang=js"
export * from "./CenterTrimOnCanvas.vue?vue&type=script&lang=js"

import "./CenterTrimOnCanvas.vue?vue&type=style&index=0&id=2c28e7e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c28e7e6"]])

export default __exports__